import React from 'react';
import { useNavigate } from 'react-router-dom';
import LoginForm from '../../components/LoginForm';
import { useAuth } from '../../context/AuthContext';
import { cognitoLogin } from '../../services/api';

const OwOwnerLogin = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleLogin = async (email, password) => {
    const data = await cognitoLogin(email, password);
    login(data, email);
    navigate('/restaurant/settings');
  };

  return <LoginForm subtitle="OW Owner Portal" onSubmit={handleLogin} />;
};

export default OwOwnerLogin;
